import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ExpensePagedCollectionQuery, ExpensePagedCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ExpensePagedCollectionQuery)
@Wrapper(ExpensePagedCollectionQueryHandlerBase)
export class ExpensePagedCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
